module.exports = __webpack_public_path__ + "static/media/selfie-face-miss.05a48f03.svg";